<first-touch-card [config]="config()" [buttonState]="buttonState()" (buttonClick)="buttonClick.emit()">
  <ng-content />
</first-touch-card>
